import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { NAV } from "@/constants/testIds";
import { Menu, X } from "lucide-react";

export default function Nav({ onReserveClick }) {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleAnchor = (e, id) => {
    setMenuOpen(false);
  };

  return (
    <nav
      data-testid={NAV.root}
      className="sticky top-0 z-40 backdrop-blur-md bg-[rgba(249,246,240,0.85)] border-b border-black/5"
    >
      <div className="max-w-[1400px] mx-auto flex items-center justify-between px-6 sm:px-10 py-4">
        <Link
          to="/"
          className="flex items-center gap-3"
          data-testid={NAV.logo}
        >
          <Logo size={56} />
        </Link>

        <div className="hidden md:flex items-center gap-10 text-[11px] tracking-[0.3em] uppercase font-body">
          <a
            href="#gallery"
            data-testid={NAV.galleryLink}
            className="hover:text-[#722F37] transition-colors"
          >
            Gallery
          </a>
          <a
            href="#artist"
            data-testid={NAV.artistLink}
            className="hover:text-[#722F37] transition-colors"
          >
            The Artist
          </a>
          <a
            href="#patronage"
            data-testid="nav-patronage-link"
            className="hover:text-[#722F37] transition-colors"
          >
            Patronage
          </a>
          <a
            href="#collectors"
            className="hover:text-[#722F37] transition-colors"
          >
            Collectors
          </a>
          <Link
            to="/admin/login"
            data-testid={NAV.adminLink}
            className="opacity-40 hover:opacity-100 hover:text-[#722F37] transition-all text-[10px]"
          >
            Admin
          </Link>
        </div>

        <div className="flex items-center gap-2">
          <button
            data-testid={NAV.reserveLink}
            onClick={onReserveClick}
            className="btn-outline-gold rounded-none px-4 sm:px-5 h-10 tracking-[0.25em] text-[10px] uppercase font-medium"
          >
            <span className="hidden sm:inline">Inquire / </span>Reserve
          </button>
          <button
            aria-label="Open menu"
            data-testid="nav-mobile-toggle"
            onClick={() => setMenuOpen((s) => !s)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-[#1A1A1A] hover:text-[#722F37] transition-colors"
          >
            {menuOpen ? (
              <X size={20} strokeWidth={1.5} />
            ) : (
              <Menu size={20} strokeWidth={1.5} />
            )}
          </button>
        </div>
      </div>

      {menuOpen && (
        <div
          className="md:hidden border-t border-black/5 bg-[var(--ivory)] fade-in"
          data-testid="nav-mobile-menu"
        >
          <div className="px-6 py-6 flex flex-col gap-5 text-[11px] tracking-[0.3em] uppercase">
            <a href="#gallery" onClick={handleAnchor}>
              Gallery
            </a>
            <a href="#artist" onClick={handleAnchor}>
              The Artist
            </a>
            <a href="#patronage" onClick={handleAnchor}>
              Patronage
            </a>
            <a href="#collectors" onClick={handleAnchor}>
              Collectors
            </a>
            <Link to="/admin/login" className="opacity-60">
              Admin
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}
